import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const MAX_ITEMS = 100;

const generateId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const normalizePayload = (payload) => {
  const data = payload?.data || {};
  const title =
    payload?.notification?.title || data.title || payload?.title || 'Notification';
  const message =
    payload?.notification?.body ||
    data.message ||
    data.body ||
    payload?.body ||
    '';
  const url = data.url || data.click_action || null;
  const type = data.type || 'general';

  return {
    id: generateId(),
    type,
    title,
    message,
    data,
    url,
    receivedAt: Date.now(),
    read: false,
  };
};

const useNotificationFeedStore = create(
  persist(
    (set, get) => ({
      items: [],

      addNotification: (payload) => {
        const item = normalizePayload(payload);
        set((state) => ({
          items: [item, ...state.items].slice(0, MAX_ITEMS),
        }));
        return item;
      },

      markRead: (id) =>
        set((state) => ({
          items: state.items.map((item) => (item.id === id ? { ...item, read: true } : item)),
        })),

      markAllRead: () =>
        set((state) => ({
          items: state.items.map((item) => (item.read ? item : { ...item, read: true })),
        })),

      clear: () => set({ items: [] }),

      unreadCount: () => get().items.filter((item) => !item.read).length,
    }),
    {
      name: 'postreams-notification-feed',
      storage: createJSONStorage(() => window.localStorage),
      partialize: (state) => ({ items: state.items.slice(0, MAX_ITEMS) }),
      version: 1,
    }
  )
);

export default useNotificationFeedStore;
